import axios from "axios";
import { NavigateFunction } from "react-router-dom";
import { logoutGygia } from "../gygia/gygia.service";
import { UserData } from "../../models/login/login.model";
import { API_ENDPOINTS } from "../../../config/endpoints.config";

const hasCookie = document.cookie
.split("; ")
.some((cookie) => cookie.startsWith("AWSELBAuthSessionCookie-0"));

const DOMAIN = API_ENDPOINTS.DOMAIN;
const LOGIN_GIGYA_URL = process.env.REACT_APP_LOGIN_GIGYA_URL 
  ? `${DOMAIN}${process.env.REACT_APP_LOGIN_GIGYA_URL}` 
  : "";

// Token variable to be used for service calls on localhost
let local_token = DOMAIN ? localStorage.getItem("authorization") || "" : "";

const setupInterceptors = (
  userData: UserData | null,
  navigate: NavigateFunction
) => {
  axios.interceptors.response.use(
    async (response) => {      
      if (response.status === 401 || response.status === 403) {

        if (hasCookie) {
          await logoutGygia();
        }
        localStorage.removeItem("userData");
        window.location.href = LOGIN_GIGYA_URL;
      }

      return response;
    },
    async (error) => {
      if (error.response.status === 401 || error.response.status === 403) {
        if (hasCookie) {
          await logoutGygia();
        }
        localStorage.removeItem("userData");
        window.location.href = LOGIN_GIGYA_URL;
      }

      return Promise.reject(error);
    }
  );

  axios.interceptors.request.use(
    async (request) => {
      if (userData && new Date(userData.expiresIn) < new Date()) {
        try {
          localStorage.setItem(
            "userData",
            JSON.stringify({
              codeVerifier: userData.codeVerifier,
              clientType: 0,
              user: "",
            })
          );
        } catch (error) {
          return Promise.reject(error);
        }
      }
      
      if (DOMAIN.includes("localhost")) {
        if (request.headers) {
          const h: any = request.headers;
          if (typeof h.set === "function") {
            h.set("Authorization", local_token);
          } else {
            (request.headers as any)["Authorization"] = local_token;
          }
        } else {
          (request as any).headers = { Authorization: local_token };
        }
      }
      return request;
    },
    (error) => Promise.reject(error)
  );
};

export default setupInterceptors;
